import { render, staticRenderFns } from "./passWord.vue?vue&type=template&id=009727ca&scoped=true"
import script from "./passWord.vue?vue&type=script&lang=js"
export * from "./passWord.vue?vue&type=script&lang=js"
import style0 from "./passWord.vue?vue&type=style&index=0&id=009727ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009727ca",
  null
  
)

export default component.exports